<template>
  <SkeletonLoader>
    <div class="recall-skeleton">
      <div class="recall-skeleton__panels">
        <div class="recall-skeleton__panel recall-skeleton__panel--wide">
          <div class="sk-line sk-line--title" style="width: 40%;"></div>
          <div class="recall-skeleton__filter-grid">
            <div v-for="i in 4" :key="'filter-' + i" class="recall-skeleton__filter-item">
              <div class="sk-line sk-line--sm" style="width: 60%; margin-bottom: 6px;"></div>
              <div class="sk-rect" style="height: 34px; width: 100%; border-radius: 4px;"></div>
            </div>
          </div>
          <div class="sk-rect" style="height: 36px; width: 120px; border-radius: 6px; margin-top: 12px;"></div>
        </div>

        <div class="recall-skeleton__panel">
          <div class="sk-line sk-line--title" style="width: 50%;"></div>
          <div class="sk-rect" style="height: 34px; width: 100%; border-radius: 4px; margin-bottom: 12px;"></div>
          <div v-for="i in 3" :key="'list-' + i" style="margin-bottom: 8px;">
            <div class="sk-line" :style="{ width: (50 + i * 10) + '%' }"></div>
          </div>
        </div>

        <div class="recall-skeleton__panel">
          <div class="sk-line sk-line--title" style="width: 45%;"></div>
          <div v-for="i in 3" :key="'goal-' + i" style="margin-bottom: 16px;">
            <div class="sk-line sk-line--sm" style="width: 40%; margin-bottom: 6px;"></div>
            <div class="sk-rect" style="height: 8px; width: 100%; border-radius: 4px;"></div>
          </div>
        </div>
      </div>

      <div class="recall-skeleton__table">
        <div class="recall-skeleton__table-header">
          <div class="sk-rect" style="height: 14px; width: 15%;"></div>
          <div class="sk-rect" style="height: 14px; width: 12%;"></div>
          <div class="sk-rect" style="height: 14px; width: 10%;"></div>
          <div class="sk-rect" style="height: 14px; width: 18%;"></div>
          <div class="sk-rect" style="height: 14px; width: 10%;"></div>
          <div class="sk-rect" style="height: 14px; width: 12%;"></div>
        </div>
        <div v-for="i in 8" :key="'row-' + i" class="recall-skeleton__table-row">
          <div class="sk-line" :style="{ width: col1[i] }"></div>
          <div class="sk-line" :style="{ width: col2[i] }"></div>
          <div class="sk-line sk-line--sm" :style="{ width: col3[i] }"></div>
          <div class="sk-line" :style="{ width: col4[i] }"></div>
          <div class="sk-rect" style="height: 22px; width: 60px; border-radius: 12px;"></div>
          <div class="sk-line sk-line--sm" :style="{ width: col5[i] }"></div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'OverdueRecallSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      col1: { 1: '14%', 2: '12%', 3: '15%', 4: '11%', 5: '13%', 6: '14%', 7: '10%', 8: '12%' },
      col2: { 1: '10%', 2: '12%', 3: '9%', 4: '11%', 5: '8%', 6: '10%', 7: '12%', 8: '9%' },
      col3: { 1: '8%', 2: '7%', 3: '9%', 4: '6%', 5: '8%', 6: '7%', 7: '9%', 8: '8%' },
      col4: { 1: '18%', 2: '15%', 3: '17%', 4: '20%', 5: '16%', 6: '19%', 7: '14%', 8: '17%' },
      col5: { 1: '10%', 2: '12%', 3: '9%', 4: '11%', 5: '13%', 6: '10%', 7: '8%', 8: '12%' },
    };
  }
}
</script>

<style lang="scss" scoped>
.recall-skeleton__panels {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.recall-skeleton__panel {
  flex: 1;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;

  &--wide {
    flex: 2;
  }
}

.recall-skeleton__filter-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 8px;
}

.recall-skeleton__table {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.recall-skeleton__table-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.recall-skeleton__table-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
}

@media (max-width: 992px) {
  .recall-skeleton__panels {
    flex-direction: column;
  }
}
</style>
